const modules = import.meta.glob('/src/components/payment/*/index.js', {
	eager: true
});

export function getPaymentModule(handler) {
	const module = modules[`/src/components/payment/${handler}/index.js`];

	if (!module) {
		throw new Error(`Payment handler "${handler}" not found`);
	}

	return module;
}
